import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Campo } from '@/componentes/campo';
import { Button } from '@/componentes/ui/button';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger,
} from '@/componentes/ui/dialog';
import { Input } from '@/componentes/ui/input';
import { mensagemDoErro, useExcluirEmpresa } from '@/dados';

import { Capitulo } from './ficha';

/* Apagar a empresa.
 *
 * A senha do administrador é exigida pela API, não por esta tela: o clique
 * acontece a uma tela de distância da lista, e digitar a senha é o que separa
 * o engano da decisão. A conta vai junto, porque empresa sem conta é registro
 * órfão contando visita no painel. */
export function Exclusao({
  id,
  nome,
  quantidades,
}: {
  id: string;
  nome: string;
  quantidades: { projetos: number; analises: number; visitas: number };
}) {
  const [aberto, setAberto] = React.useState(false);
  const [senha, setSenha] = React.useState('');
  const navegar = useNavigate();
  const excluir = useExcluirEmpresa(id);

  const enviar = (evento: React.FormEvent) => {
    evento.preventDefault();
    excluir.mutate(senha, {
      onSuccess: () => {
        setAberto(false);
        toast.success(`${nome} foi apagada.`);
        navegar('/admin?aba=empresas', { replace: true });
      },
    });
  };

  return (
    <Capitulo titulo="Apagar" descricao="Some com a empresa, a conta dela e tudo que ela preencheu.">
      <Dialog open={aberto} onOpenChange={setAberto}>
        <DialogTrigger asChild>
          <Button variant="destructive" className="justify-self-start">
            Apagar esta empresa
          </Button>
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Apagar {nome}</DialogTitle>
            <DialogDescription>
              Vão junto {quantidades.projetos} projetos, {quantidades.analises} análises e{' '}
              {quantidades.visitas} visitas, além da conta de acesso. Não há como desfazer.
            </DialogDescription>
          </DialogHeader>
          <form onSubmit={enviar} className="grid gap-4">
            <Campo
              rotulo="Sua senha"
              ajuda="A senha da sua conta de administrador."
              erro={excluir.isError ? mensagemDoErro(excluir.error) : undefined}
            >
              {(atributos) => (
                <Input
                  {...atributos}
                  type="password"
                  autoComplete="current-password"
                  value={senha}
                  onChange={(evento) => setSenha(evento.target.value)}
                />
              )}
            </Campo>
            <div className="flex justify-end gap-2">
              <Button type="button" variant="outline" onClick={() => setAberto(false)}>
                Cancelar
              </Button>
              <Button type="submit" variant="destructive" disabled={!senha || excluir.isPending}>
                {excluir.isPending ? 'Apagando' : 'Apagar'}
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </Capitulo>
  );
}
